import React from 'react';
import styles from '../styles/styles.module.css';
import QrCode from './QrCode';
import { AppState } from '../../../Redux/store';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setPassword1, setPassword2 } from '../../../Redux/slices/authSlice';

const ChangePasswordFields: React.FC = () => {
  const { qrCodeUrl, password1, password2 } = useSelector(
    (state: AppState) => state.auth
  );
  const dispatch = useDispatch();
  return qrCodeUrl ? (
    <QrCode qrCodeUrl={qrCodeUrl} />
  ) : (
    <>
      <div className={styles.inputContainer}>
        <p className={styles.label}>New Password</p>

        <input
          onChange={(e) => dispatch(setPassword1(e.target.value))}
          value={password1}
          className={styles.inputElement}
          type="password"
          required
        />
      </div>

      <div className={styles.inputContainer}>
        <p className={styles.label}>Password</p>
        <input
          onChange={(e) => dispatch(setPassword2(e.target.value))}
          value={password2}
          className={styles.inputElement}
          type="password"
          required
        />
      </div>
    </>
  );
};

export default ChangePasswordFields;
